'use client';

import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';

/** Keep distant photos out of the request queue, but preload both neighbours. */
export function TourSlideImage({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    if (typeof IntersectionObserver === 'undefined') {
      setReady(true);
      return;
    }
    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        setReady(true);
        observer.disconnect();
      },
      { root: element.closest('.ea-carousel'), rootMargin: '0px 100%' },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="h-full w-full bg-primary/10">
      {ready ? children : <noscript>{children}</noscript>}
    </div>
  );
}
